import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1855850877__a)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M9.836 5.003 3.271.909a1.05 1.05 0 0 0-1.1-.005c-.166.1-.304.246-.4.422a1.203 1.203 0 0 0-.146.58v8.188c0 .203.05.404.146.58.096.176.234.321.4.42a1.046 1.046 0 0 0 1.101-.004l6.565-4.094c.164-.101.3-.247.394-.421a1.213 1.213 0 0 0 0-1.15 1.12 1.12 0 0 0-.394-.422Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1855850877__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.75.75h10.5v10.5H.75z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play"}) } }